<footer>
  @if (showBottomCookieSelect) {
    <div class="cookie-overlay cookie-bottom-overlay">
      <div class="cookie-bar">
        <div class="buttons">
          <button (click)="openCookieSettings()">
            {{ 'cookies.definitions' | translate }}
          </button>
          <button (click)="rejectAllCookies()">{{ 'cookies.declineAll' | translate }}</button>
          <button (click)="acceptAllCookies()">{{ 'cookies.approve' | translate }}</button>
        </div>
        <div class="message" appDirByLang>
          {{ 'cookies.cookieDesc' | translate }}
        </div>
      </div>
    </div>
  }

  <div class="footer-container">
    <p>© 2024 MyFreight360. All rights reserved.</p>
    <div class="footer-links">
      <a [routerLink]="PublicPaths.TermsAndConditions">{{ 'footer.terms' | translate }}</a>
      <a [routerLink]="PublicPaths.PrivacyPolicy">{{ 'footer.privacy' | translate }}</a>
      @if (supportEmail()) {
        <a [href]="'mailto:' + supportEmail()">{{ 'footer.contactSupport' | translate }}</a>
      }
      <a (click)="openCookieSettings()" style="cursor: pointer">{{
        'footer.cookieSettings' | translate
      }}</a>
    </div>
  </div>

  <!-- שכבת המודל -->
  @if (showLeftCookieSelect) {
    <div
      #check
      class="cookie-overlay cookie-modal-overlay"
      appDirByLang
      role="dialog"
      aria-modal="true"
      aria-labelledby="dlg-title"
    >
      <div class="cookie-modal">
        <div class="modal-header">
          <div class="modal-title-wrap">
            <span class="modal-title-icon" aria-hidden="true"><i class="pi pi-verified"></i></span>
            <h2 id="dlg-title" class="title">{{ 'modal.privacyCenter' | translate }}</h2>
          </div>
          <button
            class="close"
            (click)="showLeftCookieSelect = false"
            aria-label="{{ 'modal.close' | translate }}"
          >
            ×
          </button>
        </div>

        <div class="modal-body">
          <p class="intro">
            {{ 'modal.introText' | translate }}
            <a
              href="https://cookiepedia.co.uk/giving-consent-to-cookies"
              class="intro"
              rel="noopener"
              target="_blank"
              aria-label="{{ 'modal.moreInfo' | translate }}"
              >{{ 'modal.privacyNotice' | translate }}</a
            >
          </p>

          <div class="prefs">
            <div class="pref pref-required">
              <div class="pref-head">
                <div class="pref-title-wrap">
                  <span class="chip"
                    ><i class="pi pi-shield"></i>{{ 'modal.alwaysActive' | translate }}</span
                  >
                  <span>{{ 'modal.necessaryTech' | translate }}</span>
                </div>
                <div class="pref-controls">
                  <label class="toggle toggle--disabled">
                    <input type="checkbox" class="toggle__input" checked disabled />
                    <span class="toggle__track" aria-hidden="true">
                      <span class="toggle__thumb"></span>
                    </span>
                  </label>
                </div>
              </div>
              <div class="content">{{ 'modal.necessaryDesc' | translate }}</div>
            </div>

            <div class="pref">
              <div class="pref-head">
                <span>{{ 'modal.performanceTech' | translate }}</span>
                <label class="toggle">
                  <input
                    type="checkbox"
                    class="toggle__input"
                    [(ngModel)]="blnPerformanceCookie"
                    aria-label="{{ 'modal.enablePerformance' | translate }}"
                  />
                  <span class="toggle__track" aria-hidden="true">
                    <span class="toggle__thumb"></span>
                  </span>
                </label>
              </div>
              <div class="content">{{ 'modal.performanceDesc' | translate }}</div>
            </div>

            <div class="pref">
              <div class="pref-head">
                <span>{{ 'modal.functionalTech' | translate }}</span>
                <label class="toggle">
                  <input
                    type="checkbox"
                    class="toggle__input"
                    [(ngModel)]="blnfunctionalCookie"
                    aria-label="{{ 'modal.enableFunctional' | translate }}"
                  />
                  <span class="toggle__track" aria-hidden="true">
                    <span class="toggle__thumb"></span>
                  </span>
                </label>
              </div>
              <div class="content">{{ 'modal.functionalDesc' | translate }}</div>
            </div>

            <div class="pref">
              <div class="pref-head">
                <span>{{ 'modal.analyticsTech' | translate }}</span>
                <label class="toggle">
                  <input
                    type="checkbox"
                    class="toggle__input"
                    [(ngModel)]="blnAnalyticsCookie"
                    aria-label="{{ 'modal.enableAnalytics' | translate }}"
                  />
                  <span class="toggle__track" aria-hidden="true">
                    <span class="toggle__thumb"></span>
                  </span>
                </label>
              </div>
              <div class="content">{{ 'modal.analyticsDesc' | translate }}</div>
            </div>

            <div class="pref">
              <div class="pref-head">
                <span>{{ 'modal.marketingTech' | translate }}</span>
                <label class="toggle">
                  <input
                    type="checkbox"
                    class="toggle__input"
                    [(ngModel)]="blnMarketingCookie"
                    aria-label="{{ 'modal.enableMarketing' | translate }}"
                  />
                  <span class="toggle__track" aria-hidden="true">
                    <span class="toggle__thumb"></span>
                  </span>
                </label>
              </div>
              <div class="content">{{ 'modal.marketingDesc' | translate }}</div>
            </div>
          </div>

          <div class="modal-footer">
            <button class="secondary" type="button" (click)="rejectAllSelection()">
              {{ 'cookies.declineAll' | translate }}
            </button>
            <button class="secondary" type="button" (click)="acceptAllSelection()">
              {{ 'cookies.approve' | translate }}
            </button>
            <button class="primary" type="button" (click)="saveCookiesDef()">
              {{ 'modal.confirmSelection' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</footer>
